export default "__VITE_ASSET__BUwy8dOf__"